
import momentTZ from 'moment-timezone';

export const parseDateTimeToSpecificTimezone = (date, timezone = 'Europe/Prague') => {
  const serverDate = momentTZ.tz(date, timezone);
  const serverOffset = serverDate.utcOffset();
  const localTimezone = momentTZ.tz.guess();
  const serverCloneDate = serverDate.clone().tz(localTimezone);
  const localOffset = momentTZ.tz(serverDate.format(), momentTZ.tz.guess()).utcOffset();
  const recountedOffset = serverOffset - localOffset;
  const localDate = serverCloneDate.add(recountedOffset, 'minutes');
  return localDate;
}